module.exports = __webpack_public_path__ + "img/Comerlato@2x.6085db52.png";